import { render, staticRenderFns } from "./recruitment.vue?vue&type=template&id=51135117"
import script from "./recruitment.vue?vue&type=script&lang=js"
export * from "./recruitment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports